import { useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import SubHeader from "./components/SubHeader";

const QrCode = () => {
  const navigate = useNavigate();
  const { tableNo = "T1" } = useParams<{ tableNo: string }>();
  const [searchParams] = useSearchParams();
  const amount = searchParams.get("amount") ?? "0";

  const qrUrl = useMemo(() => {
    const upiString = `upi://pay?pa=restoqueen@upi&pn=RestoQueen&am=${amount}&tn=Table%20${tableNo}&cu=INR`;
    return `https://api.qrserver.com/v1/create-qr-code/?size=628x628&margin=0&data=${encodeURIComponent(upiString)}`;
  }, [amount, tableNo]);

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-x-hidden" style={{ backgroundColor: "#F4F4F5" }} >
          {/* Header */}
          <SubHeader title="QR Code" />

          {/* Body */}
          <div className="flex flex-col items-center px-4 pt-12 pb-10">
            <p className="mt-2 font-opensans text-[16px] text-[rgba(17,17,17,0.8)] text-center max-w-[220px]">
              Please scan QR code to pay the bill
            </p>

            <div className="mt-10 w-[314px] h-[314px] bg-white p-3 rounded-[10px] flex items-center justify-center">
              <img
                src={qrUrl}
                alt="UPI QR Code"
                className="w-full h-full object-contain"
              />
            </div>

            {Number(amount) > 0 && (
              <p className="mt-6 font-sansation font-bold text-[#111] text-[18px]">
                ₹ {Number(amount).toFixed(2)}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QrCode;
